import { $ } from '@starberry/components';

export default {
    $: 'ContentSection',
    title: $('constants.translations.ourServicesModule.SERVICES_TITLE', 'Our Services'),
    props: {
        px: 12,
    },
    content: [
        {
            $: 'Grid',
            props: {
                templateColumns: { base: '1fr', xl: '1fr 1fr 1fr' },
                gap: $('constants.globalGridGap'),
            },
            children: [
                {
                    $: 'WrappedLink',
                    props: {
                        position: 'relative',
                        display: 'block',
                        h: '240px',
                        role: 'group',
                        to: '#',
                        _after: {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            w: '100%',
                            h: '100%',
                            bg: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                            opacity: 1,
                            zIndex: 2,
                        },
                        _hover: {
                            _after: {
                                opacity: 0.6,
                                transition: 'background 0.4s cubic-bezier(.17,.67,.83,.67)',
                            },
                        },
                    },
                    children: {
                        $: 'MotionImage',
                        backgroundImage: true,
                        src: 'https://via.placeholder.com/150',
                        imgContainerProps: {
                            whileHover: {},
                            w: '100%',
                            h: '100%',
                        },
                        imgProps: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        props: {
                            position: 'relative',
                            w: '100%',
                            h: '100%',
                        },
                        content: {
                            $: 'Box',
                            props: {
                                position: 'relative',
                                textAlign: 'center',
                                p: 6,
                                w: '100%',
                                zIndex: 5,
                            },
                            children: [
                                { $: 'H5', props: { as: 'h3', color: '#fff' }, children: 'Item 1 title' },
                                {
                                    $: 'Text',
                                    props: {
                                        color: '#fff',
                                        opacity: [null,null,null,null,0],
                                        visibility: [null,null,null,null,'hidden'],
                                        h: [null,null,null,null,0],
                                        transform: [null,null,null,null,'translateY(20px)'],
                                        transition: 'transform 0.4s cubic-bezier(.17,.67,.83,.67)',
                                        _groupHover: {
                                            opacity: 1,
                                            visibility: 'visible',
                                            h: 'auto',
                                            transform: ['translateY(0)'],
                                            transition: 'transform 0.4s cubic-bezier(.17,.67,.83,.67), opacity 0.2s cubic-bezier(.17,.67,.83,.67)',
                                        }
                                    },
                                    children: 'Subtitle of item 1'
                                }
                            ],
                        },
                    },
                },
                {
                    $: 'WrappedLink',
                    props: {
                        position: 'relative',
                        display: 'block',
                        h: '240px',
                        role: 'group',
                        _after: {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            w: '100%',
                            h: '100%',
                            bg: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                            opacity: 1,
                            zIndex: 2,
                        },
                        _hover: {
                            _after: {
                                opacity: 0.6,
                                transition: 'background 0.4s cubic-bezier(.17,.67,.83,.67)',
                            },
                        },
                    },
                    children: {
                        $: 'MotionImage',
                        backgroundImage: true,
                        src: 'https://via.placeholder.com/150',
                        imgContainerProps: {
                            whileHover: {},
                            w: '100%',
                            h: '100%',
                        },
                        imgProps: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        props: {
                            position: 'relative',
                            w: '100%',
                            h: '100%',
                        },
                        content: {
                            $: 'Box',
                            props: {
                                position: 'relative',
                                textAlign: 'center',
                                p: 6,
                                w: '100%',
                                zIndex: 5,
                            },
                            children: [
                                { $: 'H5', props: { as: 'h3', color: '#fff' }, children: 'Item 1 title' },
                                {
                                    $: 'Text',
                                    props: {
                                        color: '#fff',
                                        opacity: [null,null,null,null,0],
                                        visibility: [null,null,null,null,'hidden'],
                                        h: [null,null,null,null,0],
                                        transform: [null,null,null,null,'translateY(20px)'],
                                        transition: 'transform 0.4s cubic-bezier(.17,.67,.83,.67)',
                                        _groupHover: {
                                            opacity: 1,
                                            visibility: 'visible',
                                            h: 'auto',
                                            transform: ['translateY(0)'],
                                            transition: 'transform 0.4s cubic-bezier(.17,.67,.83,.67), opacity 0.2s cubic-bezier(.17,.67,.83,.67)',
                                        }
                                    },
                                    children: 'Subtitle of item 1'
                                }
                            ],
                        },
                    },
                },
                {
                    $: 'WrappedLink',
                    props: {
                        position: 'relative',
                        display: 'block',
                        h: '240px',
                        role: 'group',
                        _after: {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            w: '100%',
                            h: '100%',
                            bg: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
                            opacity: 1,
                            zIndex: 2,
                        },
                        _hover: {
                            _after: {
                                opacity: 0.6,
                                transition: 'background 0.4s cubic-bezier(.17,.67,.83,.67)',
                            },
                        },
                    },
                    children: {
                        $: 'MotionImage',
                        backgroundImage: true,
                        src: 'https://via.placeholder.com/150',
                        imgContainerProps: {
                            whileHover: {},
                            w: '100%',
                            h: '100%',
                        },
                        imgProps: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                        },
                        props: {
                            position: 'relative',
                            w: '100%',
                            h: '100%',
                        },
                        content: {
                            $: 'Box',
                            props: {
                                position: 'relative',
                                textAlign: 'center',
                                p: 6,
                                w: '100%',
                                zIndex: 5,
                            },
                            children: [
                                { $: 'H5', props: { as: 'h3', color: '#fff' }, children: 'Item 1 title' },
                                {
                                    $: 'Text',
                                    props: {
                                        color: '#fff',
                                        opacity: [null,null,null,null,0],
                                        visibility: [null,null,null,null,'hidden'],
                                        h: [null,null,null,null,0],
                                        transform: [null,null,null,null,'translateY(20px)'],
                                        transition: 'transform 0.4s cubic-bezier(.17,.67,.83,.67)',
                                        _groupHover: {
                                            opacity: 1,
                                            visibility: 'visible',
                                            h: 'auto',
                                            transform: ['translateY(0)'],
                                            transition: 'transform 0.4s cubic-bezier(.17,.67,.83,.67), opacity 0.2s cubic-bezier(.17,.67,.83,.67)',
                                        }
                                    },
                                    children: 'Subtitle of item 1'
                                }
                            ],
                        },
                    },
                },
            ],
        },
    ],
}